var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurnkeyPoker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9348 99.3907C95.68 99.3907 99.2116 99.3907 102.735 99.3907C105.618 99.3907 106.718 101.14 105.454 103.675C104.148 106.3 104.682 109.178 106.792 110.862C108.854 112.506 111.852 112.522 113.897 110.903C116.106 109.154 116.648 106.316 115.285 103.602C114.077 101.198 115.145 99.407 117.806 99.3989C121.436 99.3825 125.066 99.3989 128.853 99.3989C129.033 103.242 128.458 106.88 127.481 110.462C125.994 115.957 123.161 120.764 119.835 125.327C117.428 128.622 115.087 131.966 112.64 135.229C112.303 135.678 111.466 135.973 110.858 135.973C100.049 136.014 89.2409 136.006 78.4324 136.006C76.2313 136.006 73.6853 136.668 71.9195 135.785C70.1783 134.918 69.1763 132.522 67.9525 130.732C64.8973 126.275 61.4067 122.04 58.9756 117.265C51.3539 102.269 53.7275 84.0677 67.9443 72.6777C74.4902 67.4283 82.0462 64.7709 90.3907 64.2394C90.8342 64.2149 91.2859 64.2394 91.8773 64.2394C91.8773 67.9761 92.0005 71.5902 91.828 75.1797C91.7377 77.1503 89.783 78.0088 87.9268 77.0931C86.5141 76.398 85.1261 75.9156 83.5164 76.3326C81.2085 76.9295 79.7712 78.3523 79.2291 80.6335C78.7117 82.8249 79.418 84.6973 81.0935 86.12C82.8839 87.6409 84.9454 87.8862 87.1219 86.9704C87.3601 86.8723 87.5736 86.7333 87.8036 86.6188C89.9965 85.5477 91.8609 86.6515 91.9101 89.1127C91.9676 91.9173 91.9266 94.7218 91.9266 97.5264C91.9266 98.0824 91.9266 98.6303 91.9266 99.3989L91.9348 99.3907Z",
    fill: "url(#paint0_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.21 49.8653C130.027 51.9258 128.869 53.8391 127.809 55.8015C124.524 61.8931 127.711 69.1294 134.446 70.7239C138.265 71.6233 141.632 70.5849 144.383 67.7476C144.564 67.5677 144.712 67.3633 144.884 67.167C145.016 67.0199 145.164 66.8727 145.303 66.7255C146.79 69.0395 148.145 75.5971 147.817 79.1621C146.527 79.1621 145.221 79.1621 143.907 79.1621C141.599 79.1621 139.3 79.1539 136.992 79.1621C134.158 79.1785 133.107 80.8629 134.363 83.3649C136.047 86.7173 134.593 90.544 131.185 91.6151C128.803 92.3592 126.701 91.7868 125.066 89.9307C123.465 88.1155 123.235 86.0223 124.179 83.8064C124.278 83.5693 124.426 83.3567 124.532 83.1278C125.575 81.0019 124.483 79.1948 122.077 79.1785C118.397 79.1458 114.71 79.1703 110.792 79.1703C110.792 77.674 110.792 76.2676 110.792 74.8612C110.792 72.9724 110.792 71.0918 110.792 69.203C110.775 66.2513 109.174 65.2701 106.513 66.5865C104.468 67.5922 102.439 67.5595 100.542 66.2758C98.6447 64.9921 97.8645 63.136 98.1027 60.8547C98.4722 57.3224 102.16 55.0002 105.568 56.1777C106.045 56.3412 106.496 56.5947 106.956 56.8154C108.969 57.7639 110.743 56.7173 110.775 54.5015C110.817 51.5497 110.784 48.5898 110.792 45.6298C110.792 45.1311 110.833 44.6405 110.866 43.9863C118.233 44.0763 124.902 46.0468 131.185 49.8817L131.21 49.8653Z",
    fill: "url(#paint1_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.33 65.8175C148.769 62.8821 147.299 60.1266 145.665 57.044C144.203 59.5379 143.02 61.6638 141.739 63.7243C140.458 65.793 138.183 66.7987 135.981 66.4063C133.452 65.9565 131.867 64.4602 131.218 62.0154C130.807 60.4537 131.185 58.9982 131.99 57.6246C133.731 54.6401 135.456 51.6475 137.402 48.2869C133.559 46.1364 129.805 44.0269 125.92 41.8437C126.2 41.0097 126.462 39.9222 126.906 38.9083C127.637 37.2566 128.935 36.1201 130.766 36.0383C137.296 35.7521 143.702 34.9426 149.87 32.1626C154.625 40.3474 159.323 48.4341 164.136 56.7088C160.358 60.9034 154.896 62.6941 150.338 65.8012L150.33 65.8175Z",
    fill: "url(#paint2_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8527 159.702C85.3479 159.702 78.8432 159.71 72.3384 159.702C70.1291 159.702 68.6178 158.5 68.355 156.66C68.0511 154.501 69.5377 152.621 71.7553 152.392C72.2152 152.343 72.6751 152.375 73.1351 152.375C85.6354 152.375 98.1357 152.375 110.628 152.375C111.137 152.375 111.663 152.343 112.164 152.416C114.201 152.711 115.515 154.346 115.383 156.39C115.26 158.271 113.847 159.661 111.827 159.685C107.63 159.734 103.425 159.71 99.2281 159.71C96.7723 159.71 94.3084 159.71 91.8527 159.71V159.702Z",
    fill: "url(#paint3_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8443 140.462C98.2423 140.462 104.649 140.462 111.047 140.462C112.755 140.462 114.184 140.969 114.997 142.571C116.089 144.73 114.767 147.33 112.377 147.731C111.728 147.837 111.055 147.854 110.389 147.854C98.0534 147.854 85.7091 147.854 73.3731 147.854C72.7571 147.854 72.1411 147.837 71.5333 147.755C69.7265 147.51 68.4534 146.145 68.3549 144.378C68.2563 142.645 69.3815 141.091 71.1309 140.658C71.7633 140.503 72.445 140.47 73.102 140.462C79.3522 140.446 85.5942 140.462 91.8443 140.462Z",
    fill: "url(#paint4_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.784 164.387C105.823 169.791 98.9816 174.763 92.5343 174.984C83.8285 175.286 77.874 168.908 76.9541 164.387H106.784Z",
    fill: "url(#paint5_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.204 28.4586C153.845 27.8372 154.387 27.0195 155.151 26.627C156.481 25.9484 157.615 24.3539 159.422 25.2861C159.882 25.5232 160.235 26.0547 160.506 26.5289C164.818 33.9287 169.121 41.3367 173.409 48.7529C174.402 50.47 174.181 51.2386 172.48 52.2689C171.782 52.6941 171.076 53.1029 170.353 53.4954C168.711 54.3866 167.939 54.1822 166.961 52.5224C165.08 49.3171 163.216 46.0874 161.352 42.8658C158.945 38.7202 156.539 34.5747 154.149 30.421C153.853 29.9058 153.631 29.3417 153.213 28.4504L153.204 28.4586Z",
    fill: "url(#paint6_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3411 43.3731C94.3411 45.0002 94.3657 46.6355 94.3411 48.2627C94.3083 50.1188 93.372 51.2144 91.9182 51.1736C90.5302 51.1327 89.6268 50.0452 89.6186 48.2954C89.5939 44.9839 89.5939 41.6723 89.6186 38.369C89.6268 36.5538 90.6042 35.4172 92.0414 35.4581C93.4212 35.499 94.3083 36.5701 94.3411 38.3444C94.374 40.0206 94.3411 41.705 94.3411 43.3812V43.3731Z",
    fill: "url(#paint7_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.082 124.714C137.986 125.065 138.487 125.188 138.922 125.433C141.985 127.167 145.082 128.851 148.055 130.732C148.736 131.157 149.344 132.302 149.295 133.07C149.254 133.749 148.342 134.542 147.619 134.951C147.192 135.196 146.305 134.951 145.772 134.657C142.642 132.931 139.554 131.141 136.466 129.342C135.456 128.753 134.741 127.821 135.267 126.693C135.637 125.891 136.507 125.311 137.082 124.714Z",
    fill: "url(#paint8_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8324 127.739C48.5285 128.107 48.1178 128.933 47.4443 129.342C44.3973 131.198 41.2845 132.956 38.1635 134.697C36.8248 135.441 35.5271 135.082 34.8537 133.904C34.1802 132.727 34.5333 131.476 35.8967 130.675C38.9766 128.867 42.0648 127.077 45.1939 125.352C46.9516 124.387 48.8898 125.474 48.8241 127.739H48.8324Z",
    fill: "url(#paint9_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2027 67.1914C37.4573 67.2895 37.9994 67.4367 38.4757 67.7065C41.3996 69.3664 44.3152 71.0426 47.2145 72.727C48.7667 73.6264 49.2267 74.8774 48.5121 76.1121C47.8058 77.3468 46.4671 77.6084 44.9312 76.7335C41.8759 75.0001 38.8289 73.2421 35.7983 71.4678C34.8373 70.9036 34.3281 70.0287 34.6566 68.9003C34.9687 67.8128 35.7161 67.1914 37.2027 67.1914Z",
    fill: "url(#paint10_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9338 98.7856C35.6257 98.7856 37.3094 98.7692 39.0013 98.7856C40.726 98.8019 41.8348 99.7423 41.8266 101.132C41.8102 102.473 40.7671 103.389 39.108 103.397C35.6257 103.422 32.1516 103.422 28.6692 103.397C27.0266 103.381 25.9835 102.441 25.9999 101.091C26.0164 99.7504 27.0923 98.8183 28.7185 98.7938C30.4597 98.7692 32.2008 98.7938 33.9338 98.7938V98.7856Z",
    fill: "url(#paint11_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.692 43.9862C61.0123 44.2479 61.8337 44.6485 62.2361 45.3026C64.1005 48.3443 65.8745 51.4433 67.6321 54.5422C68.3877 55.8832 68.0263 57.1996 66.8354 57.8456C65.7349 58.4506 64.4044 58.1154 63.6734 56.8889C61.7926 53.7327 59.9364 50.5684 58.1706 47.355C57.3 45.7605 58.417 43.9944 60.692 43.978V43.9862Z",
    fill: "url(#paint12_linear_70_609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.051 103.406C148.26 103.406 146.47 103.438 144.679 103.397C143.152 103.365 142.15 102.424 142.15 101.116C142.15 99.7998 143.16 98.8104 144.663 98.7941C148.244 98.7614 151.825 98.7614 155.397 98.7941C156.909 98.8104 157.911 99.7834 157.911 101.1C157.911 102.465 156.983 103.357 155.414 103.389C153.623 103.43 151.833 103.397 150.042 103.397L150.051 103.406Z",
    fill: "url(#paint13_linear_70_609)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_609",
    x1: 91.7999,
    y1: 64.2285,
    x2: 91.7999,
    y2: 136.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_609",
    x1: 122.964,
    y1: 43.9863,
    x2: 122.964,
    y2: 91.9313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_70_609",
    x1: 145.028,
    y1: 32.1626,
    x2: 145.028,
    y2: 66.4898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_70_609",
    x1: 91.854,
    y1: 152.365,
    x2: 91.854,
    y2: 159.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_70_609",
    x1: 91.8669,
    y1: 140.455,
    x2: 91.8669,
    y2: 147.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_70_609",
    x1: 91.8691,
    y1: 164.387,
    x2: 91.8691,
    y2: 174.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_70_609",
    x1: 163.603,
    y1: 25.001,
    x2: 163.603,
    y2: 54.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_70_609",
    x1: 91.9779,
    y1: 35.457,
    x2: 91.9779,
    y2: 51.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_70_609",
    x1: 142.194,
    y1: 124.714,
    x2: 142.194,
    y2: 135.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_70_609",
    x1: 41.677,
    y1: 124.999,
    x2: 41.677,
    y2: 135.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_70_609",
    x1: 41.6987,
    y1: 67.1914,
    x2: 41.6987,
    y2: 77.2484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_70_609",
    x1: 33.9132,
    y1: 98.7783,
    x2: 33.9132,
    y2: 103.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_70_609",
    x1: 62.9513,
    y1: 43.978,
    x2: 62.9513,
    y2: 58.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_70_609",
    x1: 150.03,
    y1: 98.7695,
    x2: 150.03,
    y2: 103.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 150,
    fill: "white",
    transform: "translate(26 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnkeyPoker);
export default __webpack_public_path__ + "static/media/Turnkey_Poker.f4cdef05bed99efeaaaee077c45d4928.svg";
export { ForwardRef as ReactComponent };